import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { getAuthUser } from "../utils/auth";
import { readStoredTier } from "../utils/packageTier";

export default function ProtectedRoute({ children }) {
  const user = getAuthUser();
  const location = useLocation();

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }}
      />
    );
  }

  // Hard gate certain routes by package tier
  const path = location.pathname || "";
  const needsTier2 = path.startsWith("/community") || path.startsWith("/referrer-link");
  if (needsTier2) {
    const tierFromUser = Number(user?.packageTier);
    const resolvedTier = Number.isFinite(tierFromUser) ? tierFromUser : readStoredTier(user?.id) ?? 0;
    if (!Number.isFinite(resolvedTier) || resolvedTier < 2) {
      return (
        <Navigate
          to="/packages"
          replace
          state={{ reason: "purchase_required", from: location, feature: path.startsWith("/community") ? "community" : "referrals" }}
        />
      );
    }
  }

  return children;
}
